import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect, useState, useRef } from "react";
import InfiniteCard from "./InfiniteCard";
import apiFc from "../../services/APIFc";

interface ArticuloGrupo {
  articuloGrupoId: string;
  articuloGrupoDescripcion: string;
  articuloGrupoImagenGXI?: string;
}

export default function InfiniteScrollWrapper() {
  const [carousels, setCarousels] = useState<ArticuloGrupo[][]>([]);
  const [hasMore, setHasMore] = useState(true);
  const loadingRef = useRef(false);
  const ITEMS_PER_CAROUSEL = 12;
  const INITIAL_CAROUSELS = 3;
  const LOAD_MORE_CAROUSELS = 3;
  const RUBRO_IDS = [1, 2, 3, 4, 5, 6];
  const [currentRubroIndex, setCurrentRubroIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [preloadTriggered, setPreloadTriggered] = useState(false);

  const fetchArticulosGrupo = (rubroId: number, page: number): Promise<ArticuloGrupo[]> => {
    return apiFc
      .get(`/web/articulos/rubros/${rubroId}/articulogrupos?page=${page}&rows=${ITEMS_PER_CAROUSEL}`)
      .then((response) => {
        return response.data.content.map((item: any) => ({
          articuloGrupoId: item.articuloGrupoId.toString(),
          articuloGrupoDescripcion: item.articuloGrupoDescripcion,
          articuloGrupoImagenGXI: item.articuloGrupoImagenGXI || '',
        }));
      })
      .catch((error) => {
        console.error(`Error fetching articulos grupo for rubro ${rubroId}:`, error);
        return [];
      });
  };

  const loadCarousels = () => {
    if (loadingRef.current || currentRubroIndex >= RUBRO_IDS.length) {
      if (currentRubroIndex >= RUBRO_IDS.length) {
        setHasMore(false);
      }
      return;
    }
    
    loadingRef.current = true;
    setPreloadTriggered(false);

    let carruselesCargados = 0;
    const newCarousels: ArticuloGrupo[][] = [];

    const loadNext = () => {
      if (carruselesCargados >= LOAD_MORE_CAROUSELS || currentRubroIndex >= RUBRO_IDS.length) {
        if (newCarousels.length > 0) {
          setCarousels((prev) => [...prev, ...newCarousels]);
        }
        loadingRef.current = false;
        return;
      }

      const rubroId = RUBRO_IDS[currentRubroIndex];
      const page = currentPage;

      fetchArticulosGrupo(rubroId, page).then((items) => {
        if (items.length > 0) {
          newCarousels.push(items);
          setCurrentPage((prev) => prev + 1);
          carruselesCargados++;
          loadNext();
        } else {
          setCurrentRubroIndex((prev) => prev + 1);
          setCurrentPage(0);
          loadNext();
        }
      });
    };

    loadNext();
  };

  useEffect(() => {
    // Carga inicial
    loadCarousels();

    const handleScroll = () => {
      if (loadingRef.current || preloadTriggered) return;

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - (clientHeight * 0.2)) {
        setPreloadTriggered(true);
        loadCarousels();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <InfiniteScroll
        dataLength={carousels.length}
        next={loadCarousels}
        hasMore={hasMore}
        style={{ overflow: "hidden" }}
        loader={
          <div style={{ textAlign: "center", padding: "1rem" }}>
            <div className="spinner" />
          </div>
        }
        scrollThreshold="20%"
      >
        {carousels.map((carouselItems, index) => (
          <div key={`carousel-${index}`} style={{ marginBottom: "2rem" }}>
            <InfiniteCard
              items={carouselItems}
              preCarga={index < carousels.length - 1} 
            />
          </div>
        ))}
      </InfiniteScroll>
    </div>
  );
}